import { render, staticRenderFns } from "./CardSequenceNumber-LottoGame.vue?vue&type=template&id=a3fc0d9c&lang=pug"
import script from "./CardSequenceNumber-LottoGame.vue?vue&type=script&lang=js"
export * from "./CardSequenceNumber-LottoGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports